// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import URI from 'urijs';
import firebase from 'firebase';
import VueAnalytics from 'vue-analytics';
import i18n from './i18n';
import { PluginOptions as i18PluginOptions } from './i18n';
import * as types from '@/store/mutationTypes';
import * as Timestamps from '@/types/timestamp';
import Vuetify from 'vuetify';
import VeeValidate from 'vee-validate';
import VueClipboard from 'vue-clipboard2';
import Vue2Filters from 'vue2-filters';
import { Settings } from 'luxon';
import { PopoverPlugin } from 'bootstrap-vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import GmapCluster from 'vue2-google-maps/dist/components/cluster';
import VueCurrencyFilter from 'vue-currency-filter';

import VuetifyConfirm from 'vuetify-confirm';
import Datetime from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import 'vuetify/dist/vuetify.min.css';

import App from './App.vue';
import router from './router';
import store from './store';
import { theme } from './theme';

Vue.use(PopoverPlugin);

Vue.use(Vue2Filters);

Vue.use(VueClipboard);

Vue.use(VueAnalytics, {
  id: `${process.env.GOOGLE_ANALYTICS_KEY}`,
  router,
});

Vue.use(VuetifyConfirm, {
  buttonTrueText: 'Yes',
  buttonFalseText: 'No',
  buttonTrueColor: 'accent',
  buttonFalseColor: 'accent',
  color: 'accent',
  icon: 'warning',
  title: 'Are you sure?',
  width: 400,
  property: '$confirm',
});

Settings.defaultLocale = 'en';

Vue.use(Datetime);
Vue.use(VueGoogleMaps, {
  load: {
    key: `${process.env.REACT_APP_GOOGLE_KEY}`,
    libraries: 'places',
    language: 'en',
  },
});

Vue.component('GmapCluster', GmapCluster);

Vue.$gmapApiPromiseLazy();

Vue.use(Vuetify, { theme: theme.theme });

Object.keys(theme.theme).forEach(key => {
  document.documentElement.style.setProperty(`--${key}`, theme.theme[key]);
});

Vue.use(VeeValidate);
Vue.use(VueCurrencyFilter, {
  symbol: '$',
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: false,
});

Vue.use(i18n, i18PluginOptions);

const dict = {
  custom: {
    bidFormRate: {
      min_value: (fieldName, params) => `Your bid must be greater than $${params[0]}`,
    },
  },
};

VeeValidate.Validator.localize('en', dict);

Vue.config.productionTip = false;
Vue.prototype.$contactEmail = `${process.env.CONTACT_EMAIL}`;

router.beforeEach((to, from, next) => {
  if (to.matched.some(
    record => record.meta.authenticate || record.meta.authenticate === undefined,
  )) {
    // store.dispatch('applications/showUnauthorizedModal');
    next();
  } else {
    next();
  }
});

Vue.filter('formatDate', (dateString) => {
  if (!dateString) {
    return 'Not Provided.';
  }
  return Timestamps.formattedDate(dateString);
});

Vue.filter('formatShortDate', (dateString) => {
  if (!dateString) {
    return 'Not Provided.';
  }
  return Timestamps.formattedShortDate(dateString);
});

Vue.filter('formatDay', (dateString) => {
  if (!dateString) {
    return 'Not Provided.';
  }
  return Timestamps.formattedDay(dateString);
});

const EventBus = new Vue();

Object.defineProperties(Vue.prototype, {
  $bus: {
    get() {
      return EventBus;
    },
  },
});

let app;

// the site initially loads as LTN US. this makes an API call and saves it in the Vuex store.
store.dispatch('plugins/loadSiteDesignation').catch(console.error);

firebase.auth().onAuthStateChanged(async (currentUser) => {
  const searchParams = URI().search(true);
  if (searchParams.ln) {
    EventBus.$emit('doTokenLogin');
  } else if (currentUser) {
    store.commit(`applications/${types.START_LOADING}`);
    const isAnonymous = currentUser.isAnonymous;

    store.dispatch('applications/setCurrentUser', { currentUser: { isAnonymous } });
    const isNewUser = currentUser.metadata.creationTime === currentUser.metadata.lastSignInTime;
    if (!isAnonymous) {
      await store.dispatch('profiles/getUserProfile').catch(console.error);

      if (!isNewUser) {
        store.dispatch('companies/getCompanies');
        // TODO: we should dispatch all the different things: loads, dispatches, companies, users, etc
      } else {
        window.__insp.push(['tagSession', { userType: 'new_user' }]);
      }

      window.__insp.push(['identify', currentUser.email]);
    } else {
      window.__insp.push(['tagSession', { userType: 'Anonymous' }]);
    }

    if (!isNewUser || isAnonymous) {
      EventBus.$emit('authStateChanged');
    }

    store.commit(`applications/${types.END_LOADING}`);
  } else {
    firebase.auth().signInAnonymously();
  }

  if (!app) {
    app = new Vue({
      el: '#app',
      router,
      store,
      i18n,
      //vuetify,
      render: h => h(App)
      // components: { App },
      // template: '<App/>',
    });
  }
});



// WEBPACK FOOTER //
// ./src/main.js